// @flow
import createReducer from "common/reducerBase";
import { doListsSelection, doListsMultipleSelection } from "tabs/common/reducerMethods";
import InstagramRecord, { getNewList } from "../data/InstagramRecord";
import { types as ats } from "../actions";

export default {
	instagram: createReducer(InstagramRecord(), {

		[ats.SET_AUTH_INFO]: (state: Object, { payload }) => state.merge({
			listeningForAuth: false,
			token: payload.token,
		}),

		[ats.INIT_AUTH]: (state: Object) => state.set("listeningForAuth", true),

		[ats.SET_PHOTOS_RETRIEVE_START]: (state: Object, { payload }) => state.set("currentContext", payload.context)
			.setIn(["lists", payload.context, "inProgress"], true),

		[ats.SET_PHOTOS_RETRIEVE_SUCCESS]: (state: Object, { payload }) => state.setIn(["lists", payload.context], {
			...state.lists[payload.context],
			inProgress: false,
			items: payload.items,
			nextUrl: payload.nextUrl,
		}),

		[ats.SET_FILE_SELECTION]: doListsSelection,

		[ats.SET_MULTI_FILE_SELECTION]: doListsMultipleSelection,

		[ats.CLEAR_PHOTOS_FOR_CONTEXT]: (state: Object, { payload }) => state.setIn(["lists", payload.context], {
			...getNewList(),
			inProgress: state.lists[payload.context].inProgress,
		}),

		[ats.CLEAR_IMAGE_SELECTION]: (state: Object, { payload }) => state.setIn(["lists", payload.context, "selected"], []),

		[ats.SET_ACCOUNT_INFO_SUCCESS]: (state: Object, { payload }) => state.set("account", payload.account),

		[ats.SET_USER_LOGOUT_SUCCESS]: (state: Object) => state.replace(InstagramRecord()),

		[ats.SET_ACCOUNT_INFO_FAILED]: (state: Object) => state.merge({
			listeningForAuth: false,
			token: null,
		}),
	}),
};
